import { GetterTree } from 'vuex';
import { RootStateShape, NavigationStateShape } from 'store';

export default {
	getNavigationItem(state) {
		return (id: string) => {
			return state.navigationData[id];
		};
	}
} as GetterTree<NavigationStateShape, RootStateShape>;
